import React from 'react';

import { Shop } from '@typings/Shop';
import { OptInWidget } from '@components/OptIn/OptInWidget';

interface Props {
  shop: Shop;
}

const PublicOptInWidget = (props: Props) => <OptInWidget {...props} />;

export default PublicOptInWidget;
